import {createStyled} from '@mui/system';
import type {Theme} from './types';

export const styled = createStyled<Theme>();
export default styled;
